// src/pages/Wallet/modals/QRScannerModal.js
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { DAppContext } from '../../../contexts/DAppContext';
import ConnectionModal from '../../../components/Browser/ConnectionModal';
import walletConnectService from '../../../services/walletConnectService';
import './QRScannerModal.css';

// SVG icons for cleaner UI and better performance
const Icons = {
  QrCode: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="3" y="3" width="7" height="7"></rect>
      <rect x="14" y="3" width="7" height="7"></rect>
      <rect x="14" y="14" width="7" height="7"></rect>
      <rect x="3" y="14" width="7" height="7"></rect>
    </svg>
  ),
  Link: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
    </svg>
  ),
  Close: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  ),
  Camera: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
      <circle cx="12" cy="13" r="4"></circle>
    </svg>
  ),
  LightBulb: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M9 18h6"></path>
      <path d="M10 22h4"></path>
      <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8A6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"></path>
    </svg>
  ),
  Keyboard: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="2" y="6" width="20" height="12" rx="2"></rect>
      <line x1="6" y1="10" x2="6" y2="10"></line>
      <line x1="10" y1="10" x2="10" y2="10"></line>
      <line x1="14" y1="10" x2="14" y2="10"></line>
      <line x1="18" y1="10" x2="18" y2="10"></line>
      <line x1="6" y1="14" x2="6" y2="14"></line>
      <line x1="10" y1="14" x2="10" y2="14"></line>
      <line x1="14" y1="14" x2="14" y2="14"></line>
      <line x1="18" y1="14" x2="18" y2="14"></line>
    </svg>
  ),
  Clipboard: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
    </svg>
  ),
  Warning: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
      <line x1="12" y1="9" x2="12" y2="13"></line>
      <line x1="12" y1="17" x2="12.01" y2="17"></line>
    </svg>
  ),
  Repeat: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M17 2l4 4-4 4"></path>
      <path d="M3 11v-1a4 4 0 0 1 4-4h14"></path>
      <path d="M7 22l-4-4 4-4"></path>
      <path d="M21 13v1a4 4 0 0 1-4 4H3"></path>
    </svg>
  ),
  Check: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  ),
  Plug: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M12 22v-5"></path>
      <path d="M9 7V2"></path>
      <path d="M15 7V2"></path>
      <path d="M6 13V8h12v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4Z"></path>
    </svg>
  ),
  ExternalLink: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
      <polyline points="15 3 21 3 21 9"></polyline>
      <line x1="10" y1="14" x2="21" y2="3"></line>
    </svg>
  ),
  Trash: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M3 6h18"></path>
      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
    </svg>
  ),
  History: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
      <path d="M3 3v5h5"></path>
      <path d="M12 7v5l4 2"></path>
    </svg>
  )
};

// Script to load jsQR library dynamically (we'll use CDN to avoid npm packages)
const loadJsQR = () => {
  return new Promise((resolve, reject) => {
    // Skip if already loaded
    if (window.jsQR) {
      resolve(window.jsQR);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/jsqr@1.4.0/dist/jsQR.min.js';
    script.async = true;
    script.onload = () => resolve(window.jsQR);
    script.onerror = () => reject(new Error('Failed to load jsQR'));
    document.body.appendChild(script);
  });
};

const QRScannerModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { 
    connectWithWalletConnectUri,
    pendingConnection,
    approveConnection,
    rejectConnection,
    isWalletKitInitialized,
    activeConnections,
    disconnectFromDApp
  } = useContext(DAppContext);
  
  // State for scanner
  const [scanError, setScanError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [scannerActive, setScannerActive] = useState(false);
  const [manualUri, setManualUri] = useState('');
  const [showManualInput, setShowManualInput] = useState(false);
  const [scannedUri, setScannedUri] = useState(null);
  const [isWalletConnectReady, setIsWalletConnectReady] = useState(false);
  const [activeTab, setActiveTab] = useState('scan'); // 'scan' or 'sessions'
  const [disconnecting, setDisconnecting] = useState(null);
  const [jsQRLoaded, setJsQRLoaded] = useState(false);
  const [scanAttempts, setScanAttempts] = useState(0);
  const [isResetting, setIsResetting] = useState(false);
  // Add this new state to force enable the connect button
  const [forceEnabled, setForceEnabled] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState('unknown'); // 'connected', 'disconnected', 'connecting', 'unknown', 'ready'
  
  // Refs
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const scanIntervalRef = useRef(null);
  const connectionTimeoutRef = useRef(null);
  const lastScannedRef = useRef('');
  const connectionCheckIntervalRef = useRef(null);

  // Detect mobile device
  const isMobile = useRef(
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  );

  // Reset state when modal is opened
  useEffect(() => {
    if (isOpen) {
      // Reset processing state and connection error when modal opens
      setIsProcessing(false);
      setScanError(null);
      setScannedUri(null);
      
      // Check connection status when modal opens
      const checkConnectionStatus = async () => {
        try {
          const isConnected = walletConnectService.isConnected();
          
          // Also check if any sessions are active
          const sessions = walletConnectService.getActiveSessions();
          const hasActiveSessions = Object.keys(sessions).length > 0;
          
          if (hasActiveSessions && isConnected) {
            setConnectionStatus('connected');
          } else if (isConnected) {
            // Connected but no sessions - ready to connect
            setConnectionStatus('ready');
            setForceEnabled(true);
          } else {
            // If no sessions, make sure we're in disconnected state
            setConnectionStatus('disconnected');
            // Enable connection by default if WalletKit is initialized
            setForceEnabled(isWalletKitInitialized);
          }
        } catch (error) {
          console.error('Error checking initial connection status:', error);
          setConnectionStatus('unknown');
        }
      };
      
      checkConnectionStatus();
    }
  }, [isOpen, isWalletKitInitialized]);

  // Check WalletConnect connection status
  useEffect(() => {
    // Check connection status when modal opens
    if (isOpen) {
      const checkConnectionStatus = () => {
        try {
          const isConnected = walletConnectService.isConnected();
          const sessions = walletConnectService.getActiveSessions();
          const hasActiveSessions = Object.keys(sessions).length > 0;
          
          if (hasActiveSessions && isConnected) {
            setConnectionStatus('connected');
          } else if (isConnected && !hasActiveSessions) {
            // Connected but no sessions - ready to connect
            setConnectionStatus('ready');
            setForceEnabled(true);
            setIsProcessing(false);
          } else if (!isConnected) {
            setConnectionStatus('disconnected');
          }
        } catch (error) {
          console.error('Error checking connection status:', error);
          setConnectionStatus('unknown');
        }
      };

      // Check immediately
      checkConnectionStatus();

      // Set up interval to check periodically
      connectionCheckIntervalRef.current = setInterval(checkConnectionStatus, 3000);

      return () => {
        if (connectionCheckIntervalRef.current) {
          clearInterval(connectionCheckIntervalRef.current);
        }
      };
    }
  }, [isOpen]);

  // Check if WalletKit is initialized
  useEffect(() => {
    setIsWalletConnectReady(isWalletKitInitialized);
    
    if (isOpen && !isWalletKitInitialized) {
      setScanError('WalletConnect is initializing. Please try again in a moment or click "Force Enable" to try anyway.');
    } else if (isOpen && isWalletKitInitialized) {
      setScanError(null);
    }
  }, [isWalletKitInitialized, isOpen]);
  
  // Force enable connecting function
  const forceInitialization = async () => {
    setIsProcessing(true);
    setScanError("Attempting to initialize WalletConnect...");
    
    try {
      // Force reconnection through the service
      await walletConnectService.reconnect();
      
      // Wait a moment for reconnection to take effect
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Check connection status after attempt
      const isConnected = walletConnectService.isConnected();
      setConnectionStatus(isConnected ? 'connected' : 'disconnected');
      
      // Force enable the button regardless of initialization state
      setForceEnabled(true);
      setIsWalletConnectReady(true);
      
      setScanError("Connect button enabled. Try connecting now.");
      setIsProcessing(false);
    } catch (error) {
      console.error("Force initialization failed:", error);
      setScanError("Force initialization failed. Try resetting connections.");
      setIsProcessing(false);
      setForceEnabled(true); // Still enable the button as last resort
    }
  };
  
  // Load jsQR library when modal opens
  useEffect(() => {
    if (isOpen && !jsQRLoaded && activeTab === 'scan' && !showManualInput) {
      loadJsQR()
        .then(() => {
          console.log('jsQR loaded successfully');
          setJsQRLoaded(true);
        })
        .catch(error => {
          console.error('Failed to load jsQR:', error);
          setScanError('Failed to load QR scanner. Please try manual input.');
          setShowManualInput(true);
        });
    }
  }, [isOpen, jsQRLoaded, activeTab, showManualInput]);

  // Initialize camera and start scanning when jsQR is loaded
  useEffect(() => {
    if (!isOpen || !jsQRLoaded || showManualInput || activeTab !== 'scan') return;

    const startCamera = async () => {
      try {
        console.log('Starting camera');
        setScanError(null);
        
        // Get video element
        const video = videoRef.current;
        const canvas = canvasRef.current;
        
        if (!video || !canvas) {
          throw new Error('Video or canvas element not found');
        }
        
        // Setting video constraints - prefer back camera on mobile
        const constraints = {
          video: isMobile.current 
            ? { facingMode: { exact: 'environment' } }
            : true,
          audio: false
        };
        
        // Request camera access with better error handling
        try {
          const stream = await navigator.mediaDevices.getUserMedia(constraints);
          streamRef.current = stream;
          video.srcObject = stream;
          
          // Wait for video to be ready
          await new Promise(resolve => {
            video.onloadedmetadata = () => {
              video.play().then(resolve);
            };
          });
          
          setScannerActive(true);
          console.log('Camera started successfully');
          
          // Start scanning for QR codes
          startScanning(video, canvas);
        } catch (cameraError) {
          console.error('Camera access error:', cameraError);
          
          // Check for specific errors
          if (cameraError.name === 'NotAllowedError') {
            setScanError('Camera access denied. Please grant camera permissions and try again.');
          } else if (cameraError.name === 'NotFoundError') {
            setScanError('No camera found. Please try manual input.');
            setShowManualInput(true);
          } else if (cameraError.name === 'OverconstrainedError') {
            // Back camera not available, try again with any camera
            try {
              console.log('Back camera not available, trying any camera');
              const stream = await navigator.mediaDevices.getUserMedia({
                video: true,
                audio: false
              });
              streamRef.current = stream;
              video.srcObject = stream;
              
              await new Promise(resolve => {
                video.onloadedmetadata = () => {
                  video.play().then(resolve);
                };
              });
              
              setScannerActive(true);
              console.log('Camera started successfully with fallback');
              
              // Start scanning for QR codes
              startScanning(video, canvas);
            } catch (fallbackError) {
              console.error('Fallback camera error:', fallbackError);
              setScanError('Could not access camera. Please try manual input.');
              setShowManualInput(true);
            }
          } else {
            setScanError(`Camera error: ${cameraError.message}. Please try manual input.`);
            setShowManualInput(true);
          }
        }
      } catch (error) {
        console.error('Error starting camera:', error);
        setScanError('Failed to start camera. Please try manual input.');
        setShowManualInput(true);
      }
    };

    startCamera();

    // Cleanup function
    return () => {
      // Stop scanning
      if (scanIntervalRef.current) {
        clearInterval(scanIntervalRef.current);
        scanIntervalRef.current = null;
      }
      
      // Stop camera stream
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
        streamRef.current = null;
      }
    };
  }, [isOpen, jsQRLoaded, showManualInput, activeTab]);

  // Start scanning for QR codes
  const startScanning = (video, canvas) => {
    if (!video || !canvas || !window.jsQR) return;
    
    const context = canvas.getContext('2d');
    const scanQRCode = () => {
      if (video.readyState === video.HAVE_ENOUGH_DATA && !isProcessing) {
        // Set canvas size to match video
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        
        // Draw video frame to canvas
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        
        // Get image data
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        
        // Try to find QR code in image
        try {
          const code = window.jsQR(imageData.data, imageData.width, imageData.height, {
            inversionAttempts: "dontInvert",
          });
          
          // If QR code found
          if (code) {
            setScanAttempts(prev => prev + 1);
            console.log('QR code found:', code.data);
            
            // Process QR code if it's a WalletConnect URI
            if (code.data && code.data.indexOf('wc:') >= 0 && code.data !== lastScannedRef.current) {
              lastScannedRef.current = code.data;
              console.log('WalletConnect URI found:', code.data);
              handleQRCodeDetected(code.data);
            }
          }
        } catch (qrError) {
          console.warn('Error processing QR code:', qrError);
        }
      }
    };
    
    // Start scanning interval - higher frequency for better detection
    scanIntervalRef.current = setInterval(scanQRCode, 100);
  };

  // Handle QR code detection
  const handleQRCodeDetected = (text) => {
    if (isProcessing) return;
    
    try {
      console.log('Processing detected QR code:', text);
      setIsProcessing(true);
      
      // Extract WalletConnect URI
      const wcIndex = text.indexOf('wc:');
      if (wcIndex >= 0) {
        const wcUri = text.substring(wcIndex);
        console.log('Extracted WalletConnect URI:', wcUri);
        setScannedUri(wcUri);
        
        // Stop scanning
        if (scanIntervalRef.current) {
          clearInterval(scanIntervalRef.current);
          scanIntervalRef.current = null;
        }
        
        // Process the URI - always use wallet as handler for QR scans
        processWalletConnectUri(wcUri, 'wallet');
      } else {
        console.log('Not a valid WalletConnect QR code');
        setScanError('Not a valid WalletConnect QR code');
        setIsProcessing(false);
      }
    } catch (error) {
      console.error('Error processing QR code:', error);
      setScanError(`Error processing QR code: ${error.message}`);
      setIsProcessing(false);
    }
  };

  // Process a WalletConnect URI (from scan or input)
  const processWalletConnectUri = async (uri, handlerLocation = 'wallet') => {
    // Clean and validate URI
    let cleanUri = uri;
    
    if (uri.indexOf('wc:') > 0) {
      cleanUri = uri.substring(uri.indexOf('wc:'));
    }
    
    if (!cleanUri.startsWith('wc:')) {
      setScanError('Not a valid WalletConnect QR code');
      setIsProcessing(false);
      return;
    }
    
    // Set connection status to connecting
    setConnectionStatus('connecting');
    
    // Clear any existing timeout
    if (connectionTimeoutRef.current) {
      clearTimeout(connectionTimeoutRef.current);
    }
    
    try {
      console.log(`Starting WalletConnect connection with URI: ${cleanUri}, handler location: ${handlerLocation}`);
      
      // Set a timeout to prevent being stuck in connecting state
      connectionTimeoutRef.current = setTimeout(() => {
        console.log('Connection timeout - resetting state');
        setIsProcessing(false);
        setScanError('Connection timed out. Please try again.');
        setConnectionStatus('disconnected');
      }, 30000); // 30 second timeout
      
      // Try to force initialization before connecting if not ready
      if (!isWalletConnectReady && (forceEnabled || connectionStatus === 'disconnected')) {
        try {
          await walletConnectService.reconnect();
          await new Promise(resolve => setTimeout(resolve, 1000));
        } catch (initError) {
          console.warn('Forced initialization attempt failed:', initError);
          // Continue anyway
        }
      }
      
      const success = await connectWithWalletConnectUri(cleanUri, handlerLocation);
      
      // Clear timeout
      if (connectionTimeoutRef.current) {
        clearTimeout(connectionTimeoutRef.current);
        connectionTimeoutRef.current = null;
      }
      
      console.log('WalletConnect pairing result:', success);
      
      if (success) {
        console.log('Successfully initiated WalletConnect pairing');
        setScannedUri(cleanUri);
        setConnectionStatus('connected');
        // Reset processing state 
        setIsProcessing(false);
        onClose();
      } else {
        console.error('WalletConnect pairing failed');
        setScanError('Connection failed. Please try again.');
        setConnectionStatus('disconnected');
        setIsProcessing(false);
      }
    } catch (error) {
      // Clear timeout on error
      if (connectionTimeoutRef.current) {
        clearTimeout(connectionTimeoutRef.current);
        connectionTimeoutRef.current = null;
      }
      
      console.error('Error connecting with WalletConnect URI:', error);
      setScanError(`Error connecting: ${error.message}`);
      setConnectionStatus('disconnected');
      setIsProcessing(false);
    }
  };

  // Handle connection approval
  const handleConnectionApprove = async () => {
    if (!pendingConnection) return;
    
    setIsProcessing(true);
    try {
      const success = await approveConnection();
      
      if (success) {
        console.log("Connection successfully approved");
        onClose();
      } else {
        console.error("Connection approval failed");
        setIsProcessing(false);
        setScanError('Approval failed. Please try again.');
      }
    } catch (error) {
      console.error('Error approving connection:', error);
      setIsProcessing(false);
      setScanError('Approval failed: ' + error.message);
    }
  };
  
  // Handle connection rejection
  const handleConnectionReject = () => {
    if (!pendingConnection) return;
    
    console.log("User rejected the connection");
    rejectConnection();
    
    setIsProcessing(false);
    setScanError(null);
    
    onClose();
  };

  // Handle manual input of WalletConnect URI
  const handleManualSubmit = (e) => {
    e.preventDefault();
    if (!manualUri.trim()) return;
    
    setIsProcessing(true);
    processWalletConnectUri(manualUri.trim(), 'wallet');
  };

  // Try to paste from clipboard
  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      if (text) {
        setManualUri(text);
      }
    } catch (error) {
      console.error('Error pasting from clipboard:', error);
      setScanError('Could not access clipboard');
    }
  };

  // Reset scanner state
  const resetScanner = () => {
    setIsProcessing(false);
    setScanError(null);
    setScannedUri(null);
    lastScannedRef.current = '';
    setScanAttempts(0);
    
    // Restart scanning if active
    if (scannerActive && scanIntervalRef.current === null && videoRef.current && canvasRef.current) {
      startScanning(videoRef.current, canvasRef.current);
    }
  };

  // Reset connection (renamed from resetConnection to retryConnection)
  const retryConnection = async () => {
    setIsResetting(true);
    setScanError('Retrying WalletConnect connection...');
    
    try {
      // Reset WalletConnect service
      await walletConnectService.reconnect();
      console.log('WalletConnect service reconnected');
      
      // Clear local state
      setIsProcessing(false);
      setScanError(null);
      setScannedUri(null);
      lastScannedRef.current = '';
      setForceEnabled(true); // Enable the connect button after reconnect
      
      // Check connection status
      setTimeout(() => {
        const isConnected = walletConnectService.isConnected();
        setConnectionStatus(isConnected ? 'connected' : 'disconnected');
        setIsResetting(false);
        setScanError(isConnected ? 'WalletConnect connection restored.' : 'Connection retry complete. Please try scanning again.');
      }, 1000);
    } catch (error) {
      console.error('Error retrying WalletConnect connection:', error);
      setScanError(`Retry failed: ${error.message}`);
      setIsResetting(false);
      setForceEnabled(true); // Still enable the button as last resort
      setConnectionStatus('unknown');
    }
  };

  // Switch between camera and manual input
  const switchToCamera = async () => {
    setShowManualInput(false);
    setScanError(null);
  };

  // Handle modal close safely
  const handleCloseModal = () => {
    // Stop scanning
    if (scanIntervalRef.current) {
      clearInterval(scanIntervalRef.current);
      scanIntervalRef.current = null;
    }
    
    // Stop camera stream
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
    
    // Clear any timeouts
    if (connectionTimeoutRef.current) {
      clearTimeout(connectionTimeoutRef.current);
      connectionTimeoutRef.current = null;
    }
    
    // Clear connection check interval
    if (connectionCheckIntervalRef.current) {
      clearInterval(connectionCheckIntervalRef.current);
      connectionCheckIntervalRef.current = null;
    }
    
    // Reset state
    setIsProcessing(false);
    setScanError(null);
    
    // Close modal
    onClose();
  };

  // Handle disconnecting a dApp
  const handleDisconnect = async (url) => {
    try {
      setDisconnecting(url);
      const success = await disconnectFromDApp(url);
      
      if (success) {
        // Refresh the connection status after disconnection
        const isConnected = walletConnectService.isConnected();
        const sessions = walletConnectService.getActiveSessions();
        const hasActiveSessions = Object.keys(sessions).length > 0;
        
        if (!hasActiveSessions) {
          setConnectionStatus('disconnected');
        }
      }
      
      setDisconnecting(null);
    } catch (error) {
      console.error('Error disconnecting:', error);
      setDisconnecting(null);
    }
  };

  if (!isOpen) return null;

  // Function to get hostname from URL
  const getHostname = (url) => {
    try {
      return new URL(url).hostname;
    } catch (e) {
      return url;
    }
  };

  // Format date for display
  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  };

  // Get connection status text and color
  const getConnectionStatusInfo = () => {
    switch (connectionStatus) {
      case 'connected':
        return { text: 'Connected', color: '#4caf50' };
      case 'disconnected':
        return { text: 'Disconnected', color: '#f44336' };
      case 'connecting':
        return { text: 'Connecting...', color: '#ff9800' };
      case 'ready':
        return { text: 'Ready', color: '#2196f3' };
      default:
        return { text: 'Unknown', color: '#9e9e9e' };
    }
  };

  const statusInfo = getConnectionStatusInfo();

  return (
    <div className="qr-scanner-modal-overlay" onClick={handleCloseModal}>
      <div className="qr-scanner-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <div className="qr-scanner-modal-header">
          <h2>
            <Icons.QrCode className="qr-scanner-icon" />
            {activeTab === 'scan' 
              ? t('wallet.qrScanner.title', 'Scan WalletConnect QR Code') 
              : 'Connected DApps'}
          </h2>
          <button className="close-button-scanner" onClick={handleCloseModal}>
            <Icons.Close />
          </button>
        </div>

        {/* Tab navigation */}
        <div className="qr-scanner-modal-tabs">
          <button 
            className={`qr-scanner-tab-btn ${activeTab === 'scan' ? 'active' : ''}`}
            onClick={() => setActiveTab('scan')}
          >
            <Icons.QrCode />
            {'Scan'}
          </button>
          <button 
            className={`qr-scanner-tab-btn ${activeTab === 'sessions' ? 'active' : ''}`}
            onClick={() => setActiveTab('sessions')}
          >
            <Icons.Link />
            {'Sessions'}
            {activeConnections.length > 0 && (
              <span className="connection-count">{activeConnections.length}</span>
            )}
          </button>
        </div>

        {/* Warning Message */}
        <div className="warning-message">
          <Icons.Warning style={{ marginRight: '8px' }} />
          {t('wallet.qrScanner.walletConnectWarning', 'WalletConnect integration is currently under development. You might experience connectivity issues or unexpected behaviors.')}
        </div>

        {activeTab === 'scan' ? (
          pendingConnection ? (
            // When pendingConnection exists, hide scanner UI completely
            <div className="connection-pending-container">
              <div className="scanner-success-overlay">
                <div className="success-message">
                  <Icons.Check className="success-icon" />
                  {t('wallet.qrScanner.connected', 'Connection Successful')}
                </div>
              </div>
              <p className="scanner-instructions">
                {'Please approve or reject the connection request'}
              </p>
            </div>
          ) : showManualInput ? (
            // Manual Input Section
            <div className="manual-input-container">
              <p className="manual-input-instructions">
                {t('wallet.qrScanner.enterManually', 'Enter WalletConnect URI manually')}
              </p>
              
              <form onSubmit={handleManualSubmit} className="uri-input-form">
                <div className="uri-input-wrapper">
                  <input 
                    type="text"
                    value={manualUri}
                    onChange={(e) => setManualUri(e.target.value)}
                    placeholder="wc:..."
                    className="uri-input"
                  />
                  <button 
                    type="button" 
                    className="paste-button"
                    onClick={handlePaste}
                  >
                    <Icons.Clipboard />
                  </button>
                </div>
                
                <button 
                  type="submit" 
                  // Allow connection even if not fully ready - let user try
                  disabled={!manualUri.trim() || isProcessing}
                  className="connect-button"
                >
                  {isProcessing ? (
                    <>
                      <div className="connecting-spinner"></div>
                      {t('wallet.qrScanner.connecting', 'Connecting...')}
                    </>
                  ) : (
                    t('wallet.qrScanner.connect', 'Connect')
                  )}
                </button>
              </form>
              
              <button 
                className="switch-method-button"
                onClick={switchToCamera}
                disabled={isProcessing}
              >
                <Icons.Camera />
                {t('wallet.qrScanner.scanInstead', 'Scan with Camera Instead')}
              </button>
              
              {scanError && (
                <div className="scan-error">
                  {scanError}
                  <button 
                    className="retry-button" 
                    onClick={forceInitialization}
                    disabled={isProcessing}
                  >
                    <Icons.Repeat /> Force Enable
                  </button>
                </div>
              )}

            </div>
          ) : (
            // Camera Scanner Section
            <>
              <div className="qr-scanner-container">
                <div className="scan-overlay">
                  <div className="scan-target">
                    <div className="bottom-left"></div>
                    <div className="bottom-right"></div>
                  </div>
                </div>
                
                {isProcessing && !pendingConnection && (
                  <div className="scanner-processing-overlay">
                    <div className="connecting-message">
                      <div className="connecting-spinner"></div>
                      {t('wallet.qrScanner.connecting', 'Connecting...')}
                    </div>
                  </div>
                )}
                
                {/* The video element that shows camera feed */}
                <video 
                  ref={videoRef} 
                  className="scanner-video"
                  playsInline 
                  muted
                  style={{ 
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover',
                    position: 'absolute',
                    top: 0,
                    left: 0
                  }}
                />
                
                {/* Hidden canvas for QR code detection */}
                <canvas 
                  ref={canvasRef} 
                  style={{ display: 'none' }}
                />
              </div>

              <div className="scanner-instructions">
                {isProcessing && !pendingConnection ? (
                  <div className="connecting-message">
                    <div className="connecting-spinner"></div>
                    {t('wallet.qrScanner.connecting', 'Connecting...')}
                  </div>
                ) : (
                  <p>{t('wallet.qrScanner.instructions', 'Point camera at a WalletConnect QR code')}</p>
                )}
              </div>

              <div className="scanner-controls">
                <button 
                  className="scanner-button manual-button"
                  onClick={() => setShowManualInput(true)}
                  disabled={isProcessing}
                >
                  <Icons.Keyboard />
                  {t('wallet.qrScanner.enterManually', 'Enter Manually')}
                </button>
                
                {isProcessing && !pendingConnection ? (
                  <button 
                    className="scanner-button cancel-button"
                    onClick={resetScanner}
                  >
                    <Icons.Close />
                    {t('wallet.qrScanner.cancel', 'Cancel')}
                  </button>
                ) : (
                  <button 
                    className="scanner-button reset-button"
                    onClick={retryConnection}
                    disabled={isResetting}
                  >
                    {isResetting ? (
                      <div className="connecting-spinner"></div>
                    ) : (
                      <Icons.Repeat />
                    )}
                    Retry Connection
                  </button>
                )}
              </div>
            </>
          )
        ) : (
          // Sessions List Section
          <div className="sessions-list-container">
            {activeConnections.length === 0 ? (
              <div className="no-connections">
                <Icons.Plug className="no-connections-icon" />
                <p>{'No connected DApps'}</p>
                <button 
                  className="connect-button"
                  onClick={() => setActiveTab('scan')}
                >
                  {'Connect New DApp'}
                </button>
              </div>
            ) : (
              <>
                <div className="sessions-list">
                  {activeConnections.map((connection) => (
                    <div key={connection.url} className="session-item">
                      <div className="session-icon">
                        <img 
                          src={`https://${getHostname(connection.url)}/favicon.ico`}
                          alt=""
                          onError={(e) => {e.target.src = '/assets/wallet-logo.png'}}
                        />
                      </div>
                      <div className="session-info">
                        <div className="session-name">
                          {connection.name || getHostname(connection.url)}
                        </div>
                        <div className="session-url">
                          {getHostname(connection.url)}
                          <a 
                            href={connection.url} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="external-link"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <Icons.ExternalLink />
                          </a>
                        </div>
                        <div className="session-details">
                          <span className="session-type">
                            {connection.connectionType === 'walletconnect' 
                              ? 'WalletConnect' 
                              : 'Injected'}
                          </span>
                          <span className="session-location">
                            {connection.wcHandlerLocation === 'wallet' 
                              ? 'Wallet' 
                              : 'Browser'}
                          </span>
                          {connection.timestamp && (
                            <span className="session-date">
                              <Icons.History />
                              {formatDate(connection.timestamp)}
                            </span>
                          )}
                        </div>
                      </div>
                      <button 
                        className="disconnect-button"
                        onClick={() => handleDisconnect(connection.url)}
                        disabled={disconnecting === connection.url}
                      >
                        {disconnecting === connection.url ? (
                          <div className="connecting-spinner"></div>
                        ) : (
                          <Icons.Trash />
                        )}
                      </button>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        )}
      </div>
      
      {/* Connection Modal */}
      {pendingConnection && (
        <ConnectionModal 
          isOpen={!!pendingConnection}
          onClose={handleConnectionReject}
          site={pendingConnection?.url || ''}
          hostname={pendingConnection ? new URL(pendingConnection.url).hostname : ''}
          onApprove={handleConnectionApprove}
          onReject={handleConnectionReject}
          isLoading={isProcessing}
          connectionType={pendingConnection?.connectionType || 'walletconnect'}
          securityInfo={pendingConnection?.securityInfo}
        />
      )}
    </div>
  );
};

export default QRScannerModal;